import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./App/store.js";
import ChunkErrorBoundary from "./Components/ChunkErrorBoundary.jsx";

const container = document.getElementById("root");
const root = createRoot(container);

// Minimal loading fallback shown only for the brief moment redux-persist takes
// to rehydrate `auth`/`permissions` from localStorage. Gating render on this is
// what prevents the "auto-logout on refresh" race: the auth gate in App.js reads
// the rehydrated `auth.user`, so App must not mount until rehydration completes.
const RehydrateFallback = () => (
    <div
        style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            font: "14px system-ui, sans-serif",
            color: "#666",
        }}
    >
        Loading…
    </div>
);

root.render(
    <React.StrictMode>
        <Provider store={store}>
            <PersistGate loading={<RehydrateFallback />} persistor={persistor}>
                {/* Last line of defence: the per-route boundary (RoutesTree) doesn't
                    cover the shell — Nav, palette, SOP host, WhatsApp provider. */}
                <ChunkErrorBoundary>
                    <App />
                </ChunkErrorBoundary>
            </PersistGate>
        </Provider>
    </React.StrictMode>
);
